module.exports = __webpack_public_path__ + "img/square-circle-2.890a6612.png";